import React from 'react';
import ReactDOM from 'react-dom';

const Portal = (props) => {
  const { children, mountNode = document.body } = props;
  return ReactDOM.createPortal(
    children,
    mountNode
  );
}

export default Portal;